import API from '@/services/spinampApi';
import {IPlaylist} from '@/types/playlists';

export const fetchTrendingPlaylistsData = (): Promise<IPlaylist[]> =>
  API.get('trendingPlaylists');
